import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {
  constants,
  getNumberOrNull,
  responseSelector,
  toTitleCase,
} from '../utils/utils';
import {useAlerts} from '../ui/alert';
import {alertTypes} from '../utils/Alert';
import {log} from '../utils/logs';
import {createInstitutoDuck, createInstitutoThunk} from './duck';
import {CrearInstitutoView} from './CrearInstitutoView';

function CrearInstituto({history, match, token}) {
  const dispatch = useDispatch();

  const modelCreateInstituto = useSelector(state => state.createInstituto);

  const [nombre, setNombre] = useState('');
  const [direccion, setDireccion] = useState('');
  const [telefono, setTelefono] = useState('');
  const [contactoNombre, setContactoNombre] = useState('');
  const [contactoTelefono, setContactoTelefono] = useState('');

  const {topAlert, setTopAlert, submitAlert, setSubmitAlert} = useAlerts();

  useEffect(() => {
    const {data, code, message, httpStatus, error, errorMessage} =
      responseSelector(modelCreateInstituto);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(createInstitutoDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      dispatch(createInstitutoDuck.actions.clear());

      setTopAlert({
        text: 'Instituto creado correctamente',
        type: alertTypes.success,
        closable: false,
      });
    }
  }, [modelCreateInstituto]);

  function submit() {
    let data = {
      userToken: token.raw,
      nombre,
      direccion,
      telefono,
      contactoNombre,
      contactoTelefono,
    };

    log({'submit.data': data});

    dispatch(createInstitutoThunk(data));
  }

  return (
    <CrearInstitutoView
      history={history}
      match={match}
      modelCreateInstituto={modelCreateInstituto}
      submit={submit}
      submitAlert={submitAlert}
      topAlert={topAlert}
      nombre={nombre}
      setNombre={setNombre}
      direccion={direccion}
      setDireccion={setDireccion}
      telefono={telefono}
      setTelefono={setTelefono}
      contactoNombre={contactoNombre}
      setContactoNombre={setContactoNombre}
      contactoTelefono={contactoTelefono}
      setContactoTelefono={setContactoTelefono}
    />
  );
}

export {CrearInstituto};
